export default "__VITE_ASSET__fb505dc1__"